import { Injectable, inject } from '@angular/core';
import { VIEWED_STORIES } from 'src/app/contracts';
import { SETTINGS } from 'src/app/core/contracts';
import { clearStorage, getStorageKeys } from 'src/app/core/helpers/storage';
import { AddressesData } from 'src/app/data/addresses.data';
import { MarketingData } from 'src/app/data/marketing.data';
import { PaymentCardsData } from 'src/app/data/payment-cards.data';
import { PointsData } from 'src/app/data/points.data';
import { PromotionCodesData } from 'src/app/data/promotion-codes.data';
import { WalletData } from 'src/app/data/wallet.data';

@Injectable({ providedIn: 'root' })
export class DataServices {
  private addresses = inject(AddressesData);
  private points = inject(PointsData);
  private codes = inject(PromotionCodesData);
  private marketing = inject(MarketingData);
  private wallet = inject(WalletData);
  private cards = inject(PaymentCardsData);

  async dispose() {
    const clearStorageData = () =>
      getStorageKeys()
        .then(keys => keys.filter(key => key !== SETTINGS && key !== VIEWED_STORIES)) // added VIEWED_STORIES because it's getting cleared regularly from handleUnauthorizedAccess() due to the short lifespan of the access token
        .then(keys => clearStorage(keys));
    const promises = [
      this.addresses.dispose(),
      this.points.dispose(),
      this.codes.dispose(),
      this.marketing.dispose(),
      this.wallet.dispose(),
      this.cards.dispose(),
      clearStorageData(),
    ];
    return Promise.all(promises.map(p => p.catch((e: unknown) => e)));
  }
}
